import React, { useState, useEffect } from 'react';
import { forwardRef } from 'react';
import Grid from '@material-ui/core/Grid';
import MaterialTable from '@material-table/core';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { ExportCsv } from '@material-table/exporters';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useLocation } from 'react-router-dom';
// import CompoundSlider from "./CompoundSlider";
import Button from '@material-ui/core/Button';

import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import { useAuth } from '../../hooks/useAuth';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    // margin: theme.spacing(1),
    width: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  card: {
    width: '100%',
  },
  appenList: {},
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export default function ReservationsReportV2() {
  // Use this url for testing
  // username: uniper+report+user password: E7yzc3q8zEw9nDym
  // http://localhost:3000/#/reservations_report_v2?organization=153&location=199&t=4677042a-549f-487a-bba4-9fe0e6b50913
  // http://localhost:3000/reservations_report_v2?organization=153&location=199&id=112164967

  let date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  const epochTime = date.getTime();
  const [startDate, setStartDate] = useState(epochTime - 604800000); // search results 1 week before start time
  const [endDate, setEndDate] = useState(epochTime);

  if (typeof startDate !== 'number') {
    setStartDate(startDate.getTime());
  }
  if (typeof endDate !== 'number') {
    setEndDate(endDate.getTime());
  }

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orgId = queryParams.get('organization');
  const locId = queryParams.get('location');
  const assetid = queryParams.get('id');

  const { token } = useAuth();
  const [selectedFloor, setSelectedFloor] = useState([]);
  const [assetType, setAssetType] = useState('room');
  const [skipWeekends, setskipWeekends] = useState(true);
  const [disable, setDisable] = useState(false);
  // const { hourStart, hourEnd } = useState([]);

  /* const handleHours = (range) => {
    setFilters({
      hourStart: range[0],
      hourEnd: range[1],
    });
  };
 */
  // const measurementsUrl = `https://eu-api.empathicbuilding.com/v1/organizations/${orgId}/locations/${locId}/measurements/reservation?start=${
  //   startDate - 604800000
  // }&end=${endDate}&ignore_previous_validity=true&limit=50000&asset_type=${assetType}&floor_id=${selectedFloor}`;

  const measurementsUrl = `https://eu-api.empathicbuilding.com/v1/organizations/${orgId}/locations/${locId}/measurements/reservation?start=${
    startDate - 604800000
  }&end=${endDate}&ignore_previous_validity=true&limit=50000&asset_type=${assetType}`;

  const assetsUrl = `https://eu-api.empathicbuilding.com/v1/organizations/${orgId}/locations/${locId}/assets`;
  const reservationsensorsUrl = `https://eu-api.empathicbuilding.com/v1/organizations/${orgId}/locations/${locId}/sensors?sensor_type=reservation`;

  const api = axios.create({
    baseURL: 'https://eu-api.empathicbuilding.com/v1',
    headers: { Authorization: `Bearer ${token}` },
  });

  const initialColumns = [
    {
      title: 'Reservation date',
      field: 'reservation_date',
    },
    {
      title: 'Bookable assets',
      field: 'bookable',
    },
    {
      title: 'Capacity in hours',
      field: 'bookable_capacity',
    },
    {
      title: 'Number of reservations',
      field: 'reservations_count',
    },
    {
      title: 'Reserved hours',
      field: 'total_reserved_time',
    },
    {
      title: 'Reservation %',
      field: 'reservation_percentage',
    },
    {
      title: 'Asset count',
      field: 'asset_count',
    },
  ];
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(initialColumns);
  const [title, setTitle] = useState('');
  const [locationname, setLocationName] = useState('');

  const [assetsdata, setAssetsData] = useState([]);
  const [iserror] = useState(false);
  const [errorMessages] = useState([]);
  let final_list = [];
  let grouped_list = [];
  let asset_ids = [];
  let asset = 0;
  let assetnames = '';
  let bookable_assets = [];
  let dailyhours = 0;
  const groupBy = (array, key) => {
    return array.reduce((result, currentItem) => {
      (result[currentItem[key]] = result[currentItem[key]] || []).push(
        currentItem
      );
      return result;
    }, {});
  };

  const hourdiff = (start, end) => {
    start = start.split(':');
    end = end.split(':');
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    return (
      (hours < 9 ? '0' : '') + hours + ':' + (minutes < 9 ? '0' : '') + minutes
    );
  };
  const dates = [];
  const getDatesInRange = (startDate, endDate, excludeWeekEnds) => {
    const sdate = new Date(startDate);
    const edate = new Date(endDate);

    while (sdate <= edate) {
      if (excludeWeekEnds && (sdate.getDay() === 6 || sdate.getDay() === 0)) {
        sdate.setDate(sdate.getDate() + 1);
        continue;
      } else {
        dates.push(new Date(sdate));
        sdate.setDate(sdate.getDate() + 1);
      }
    }

    return dates;
  };

  const classes = useStyles();
  const [floorNames, setFloorNames] = useState([]);
  const [floor, setFloorName] = useState([]);
  const isAllSelected =
    floorNames.length > 0 && floor.length === floorNames.length;
  useEffect(() => console.log(floor), [floor, isAllSelected], selectedFloor);

  const handleChange = (event) => {
    if (
      event.target.value.includes('all') &&
      floor.length !== floorNames.length
    ) {
      setFloorName(floorNames.map((name) => name.id));
    } else if (event.target.value.includes('all')) {
      setFloorName([]);
    } else {
      setFloorName(event.target.value);
    }
    setSelectedFloor(event.target.value);
  };

  const getSelectValues = (selected) => {
    return floorNames
      .filter((name) => selected.includes(name.id))
      .map((record) => record.name)
      .join(', ');
  };

  useEffect(() => {
    const fetchFloors = async () => {
      const assets = await api.get(assetsUrl);
      setAssetsData(assets.data);
      if (assetid) {
        const location_asset = assets.data.filter(
          (asset) => asset['id'] === assetid
        );
        setLocationName(location_asset[0]['name']);
      }
      let currentBuildingFloors = [];
      assets.data.forEach((asset) => {
        if (asset['type'] === 'floor') {
          const building = assets.data.filter((obj) => {
            return obj.id === asset['parent_id'];
          });
          currentBuildingFloors.push({
            id: parseInt(asset['id']),
            name: building[0]['name'] + ' - ' + asset['name'],
          });
        }
      });

      currentBuildingFloors.sort(function (x, y) {
        let a = x.name.toUpperCase(),
          b = y.name.toUpperCase();
        return a === b ? 0 : a > b ? 1 : -1;
      });
      setFloorNames(
        currentBuildingFloors.map((floor) => ({
          id: floor.id,
          name: floor.name,
        }))
      );
    };
    fetchFloors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#4caf50',
      },
      secondary: {
        main: '#ff9100',
      },
    },
  });

  const handleAssetTypeChange = (e) => {
    setAssetType(e.target.value);
  };
  const handleClick = async () => {
    // setIsLoading(true);
    setDisable(true);
    setData([]);
    setTitle('');
    try {
      // build the reservation table
      getDatesInRange(startDate, endDate, skipWeekends);
      console.log('Selected dates: ', dates.length, ' ', ...dates.entries());

      let measurements = [];
      if (selectedFloor.length > 0 && !isAllSelected) {
        const url = new URL(measurementsUrl);
        selectedFloor.forEach((floor) => {
          url.searchParams.append('floor_id', floor);
        });
        measurements = await api.get(url.href);
      } else {
        measurements = await api.get(measurementsUrl);
      }
      const assets = assetsdata.filter((asset) => asset['type'] === assetType);
      const sensors = await api.get(reservationsensorsUrl);
      assets.forEach((asset) => {
        if (isAllSelected) {
          if (asset.hasOwnProperty('data_providers')) {
            asset['data_providers'].forEach((data_provider) => {
              let sensor = sensors.data.filter(function (value) {
                return value.id === data_provider;
              });
              if (sensor.length > 0) {
                bookable_assets.push({
                  asset_id: asset['id'],
                  parent_id: asset['parent_id'],
                  asset_type: asset['type'],
                  asset_name: asset['name'],
                  sensor_id: sensor[0]['id'],
                  sensor_type: sensor[0]['type'],
                  vendor: sensor[0]['vendor'],
                  vendor_id: sensor[0]['vendor_id'],
                });
              }
            });
          }
        } else {
          if (selectedFloor.includes(parseInt(asset['parent_id']))) {
            if (asset.hasOwnProperty('data_providers')) {
              asset['data_providers'].forEach((data_provider) => {
                let sensor = sensors.data.filter(function (value) {
                  return value.id === data_provider;
                });
                if (sensor.length > 0) {
                  bookable_assets.push({
                    asset_id: asset['id'],
                    parent_id: asset['parent_id'],
                    asset_type: asset['type'],
                    asset_name: asset['name'],
                    sensor_id: sensor[0]['id'],
                    sensor_type: sensor[0]['type'],
                    vendor: sensor[0]['vendor'],
                    vendor_id: sensor[0]['vendor_id'],
                  });
                }
              });
            }
          }
        }
      });

      console.log(
        'Bookable assets: ',
        bookable_assets.length,
        ' ',
        ...bookable_assets.entries()
      );

      let reservations_list = [];
      let total_reservation_capacity = 0;
      measurements.data.rows.forEach((reservation) => {
        if (
          typeof reservation[3] !== 'undefined' &&
          reservation[3].length > 0
        ) {
          reservation[3].forEach((item) => {
            if (item.start >= startDate && item.end <= endDate) {
              let valid_sensor = bookable_assets.filter(
                (a) => a['sensor_id'] === reservation[2]
              )[0];
              if (valid_sensor) {
                var seconds = (item['end'] - item['start']) / 1000;
                reservations_list.push({
                  reservation_date: new Date(item['start']).toDateString(),
                  sensor_id: reservation[2],
                  start: new Date(item['start']).toLocaleString(),
                  end: new Date(item['end']).toLocaleString(),
                  subject: item['subject'],
                  reservation_time: seconds / 3600,
                });
              }
            }
          });
        }
      });
      reservations_list = reservations_list.sort(function compare(obj1, obj2) {
        return (
          new Date(obj1.reservation_date) - new Date(obj2.reservation_date)
        );
      });
      grouped_list = groupBy(reservations_list, 'reservation_date');
      console.log('Datewise total reservations: ', grouped_list);

      let reservation_date;
      let reservations_count = 0;

      let daily_total_reservation_time = 0;
      let total_reservation_time = 0;
      if (bookable_assets.length > 0) {
        let start = '08:00';
        let end = '17:00';
        dailyhours = hourdiff(start, end);
        total_reservation_capacity =
          parseInt(bookable_assets.length) *
          parseInt(dates.length) *
          parseInt(dailyhours);
        console.log('Total capacity in hours: ', total_reservation_capacity);
      }
      let daily_bookable_capacity =
        parseInt(bookable_assets.length) * parseInt(dailyhours);
      Object.entries(dates).forEach((date) => {
        reservation_date = date[1].toDateString();
        let item = grouped_list[reservation_date];
        if (item !== undefined) {
          if (item.length > 0) {
            Object.entries(item).forEach((sensor) => {
              asset = bookable_assets.filter(
                (a) => a['sensor_id'] === sensor[1]['sensor_id']
              )[0];
              if (asset) {
                daily_total_reservation_time =
                  daily_total_reservation_time + sensor[1]['reservation_time'];
                reservations_count += 1;
                if (
                  !asset_ids.some(
                    (arrayasset) => arrayasset.id === asset['asset_id']
                  )
                ) {
                  asset_ids.push({
                    id: asset['asset_id'],
                    name: asset['asset_name'],
                  });
                  assetnames = assetnames.concat(asset['asset_name'], ' ');
                }
              }
            });

            const finalObject = {
              reservation_date: reservation_date,
              bookable: bookable_assets.length,
              bookable_capacity: daily_bookable_capacity,
              reservations_count: reservations_count,
              asset_ids: asset_ids,
              asset_count: asset_ids.length,
              total_reserved_time: daily_total_reservation_time.toFixed(2),
              reservation_percentage: (
                (daily_total_reservation_time / daily_bookable_capacity) *
                100
              ).toFixed(2),
            };

            // Loop asset_ids and push them to the object so we can display assets individually in report
            asset_ids.forEach((asset) => {
              finalObject[asset.id] = asset.name;
              const isAssetInColumns = initialColumns.find(
                (column) => column.title === 'Asset_' + asset.id
              );
              if (!isAssetInColumns) {
                initialColumns.push({
                  title: 'Asset_' + asset.id,
                  field: asset.id,
                });
              }
            });

            setColumns(initialColumns);
            final_list.push(finalObject);

            total_reservation_time =
              total_reservation_time + daily_total_reservation_time;
          }
        } else {
          final_list.push({
            reservation_date: reservation_date,
            bookable: bookable_assets.length,
            bookable_capacity:
              parseInt(bookable_assets.length) * parseInt(dailyhours),
            reservations_count: 0,
            asset_ids: '',
            asset_count: 0,
            total_reserved_time: 0,
            reservation_percentage: 0,
          });
        }
        asset_ids = [];
        asset = 0;
        assetnames = '';
        daily_total_reservation_time = 0;
        reservations_count = 0;
      });
      setData(final_list);
      let titletext =
        'Overall % reservation: ' +
        ((total_reservation_time / total_reservation_capacity) * 100).toFixed(
          2
        );
      setTitle(titletext);
      total_reservation_time = 0;
      setDisable(false);
    } catch (err) {
      console.log(err.message);
      // setErr(err.message);
    } finally {
      // setIsLoading(false);
      setDisable(false);
    }
  };

  return (
    <MuiThemeProvider theme={theme}>
      <div>
        <Grid container spacing={1} style={{ width: '100%' }}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <div>
              {iserror && (
                <Alert severity="error">
                  {errorMessages.map((msg, i) => {
                    return <div key={i}>{msg}</div>;
                  })}
                </Alert>
              )}
            </div>
            <h1>Reservations report - {locationname} </h1>
            <div
              style={{
                display: 'flex',
                gap: '2rem',
                justifyContent: 'flex-start',
                marginBottom: '1rem',
              }}
            >
              <FormControl id="assetType" style={{ width: '7rem' }}>
                <InputLabel>Asset type</InputLabel>
                <Select
                  value={assetType}
                  label="Asset type"
                  onChange={handleAssetTypeChange}
                >
                  <MenuItem key="room" value="room">
                    Room
                  </MenuItem>
                  <MenuItem key="desk" value="desk">
                    Desk
                  </MenuItem>
                </Select>
              </FormControl>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  label="Start date"
                  format="dd/MM/yyyy"
                  value={startDate}
                  onChange={setStartDate}
                  style={{ width: '7rem' }}
                />
                <DatePicker
                  label="End date"
                  format="dd/MM/yyyy"
                  value={endDate}
                  onChange={setEndDate}
                  style={{ width: '7rem' }}
                />
              </MuiPickersUtilsProvider>
              <FormControl
                style={{ width: '20rem' }}
                className={classes.formControl}
              >
                <InputLabel id="demo-mutiple-checkbox-label">
                  Floor(s)
                </InputLabel>
                <Select
                  labelId="demo-mutiple-checkbox-label"
                  id="demo-mutiple-checkbox"
                  multiple
                  value={floor}
                  onChange={handleChange}
                  input={<Input />}
                  renderValue={getSelectValues}
                  MenuProps={MenuProps}
                >
                  <MenuItem
                    value="all"
                    classes={{
                      root: isAllSelected ? classes.selectedAll : '',
                    }}
                  >
                    <ListItemIcon>
                      <Checkbox
                        classes={{ indeterminate: classes.indeterminateColor }}
                        checked={isAllSelected}
                        indeterminate={
                          floor.length > 0 && floor.length < floorNames.length
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.selectAllText }}
                      primary="Select All"
                    />
                  </MenuItem>
                  {floorNames.map((item, index) => (
                    <MenuItem key={item.id} value={item.id}>
                      <Checkbox checked={floor.indexOf(item.id) > -1} />
                      <ListItemText primary={item.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <label>
                  <input
                    type="checkbox"
                    value={skipWeekends}
                    checked={skipWeekends}
                    onChange={(e) => {
                      setskipWeekends();
                    }}
                  />
                  &nbsp;Exclude weekends (Sat. and Sun.)
                </label>
              </FormControl>
              {/* {<FormControl>
                <label>
                  Office hours: {hourStart}-{hourEnd}
                </label>
                <CompoundSlider
                  domain={[0, 24]}
                  defaultValues={[hourStart, hourEnd]}
                  step={1}
                  showTicks={true}
                  onChange={handleHours}
                />
              </FormControl>} */}

              <FormControl id="search">
                <Button
                  color="primary"
                  variant="contained"
                  disabled={disable}
                  size="large"
                  onClick={handleClick}
                >
                  Generate report
                </Button>
              </FormControl>
            </div>
            <MaterialTable
              title={title}
              columns={columns}
              data={data}
              icons={tableIcons}
              options={{
                exportAllData: true,
                pageSize: 10,
                exportMenu: [
                  {
                    label: 'Export CSV',
                    exportFunc: (cols, datas) =>
                      ExportCsv(cols, datas, 'Reservations_report'),
                  },
                ],
              }}
            />
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
      </div>
    </MuiThemeProvider>
  );
}
